import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import {
  NavController,
  NavParams,
  LoadingController,
  AlertController,
  ModalController,
  IonicModule,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { EMPTY, Observable } from "rxjs";
import { EnderecoProvider } from "src/app/services/endereco/endereco";
import { MapaProvider } from "src/app/services/mapa/mapa";
import { PessoaProvider } from "src/app/services/pessoa/pessoa";
import { UserProvider } from "src/app/services/user/user";
import { Geolocation } from "@capacitor/geolocation";
import { CommonModule } from "@angular/common";
import { NgxMaskDirective, NgxMaskPipe } from "ngx-mask";

const idBrasil = 27;
const idDubai = 2;
declare var google: any;
declare var instituicaoConstants: { BUSCAR_INTITUICOES: number };

@Component({
  selector: "app-pessoa-edit-endereco",
  templateUrl: "./pessoa-edit-endereco.page.html",
  styleUrls: ["./pessoa-edit-endereco.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    TranslateModule,
    NgxMaskPipe,
    NgxMaskDirective,
  ],
})
export class PessoaEditEnderecoPage implements OnInit {
  @ViewChild("searchbar", { read: ElementRef }) searchbar!: ElementRef;
  pais: any;
  validations_form_internacional: FormGroup;
  validations_form: FormGroup;
  addressElement: HTMLInputElement;
  address = "";
  enderecoSelecionado: any;
  components: any;
  idInstituicao: any;
  teste: unknown;
  componentEndereco: any;
  endereco: any;
  paisList: any;
  regiao: any;
  paises: any;
  estados: any;
  cidades: any;
  selecionado = false;
  dubai = false;
  semEstado = false;
  fromForm = false;
  semSalvar = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public pessoaProvider: PessoaProvider,
    public userProvider: UserProvider,
    public loadingController: LoadingController,
    public translate: TranslateService,
    public modalCtrl: ModalController,
    public enderecoProvider: EnderecoProvider,
    public mapaService: MapaProvider,
    public alertCtrl: AlertController
  ) {
    this.endereco = this.navParams.get("endereco");
    this.fromForm = this.navParams.get("fromForm");
    this.semSalvar = this.navParams.get("semSalvar");

    this.isInitForms();

    this.enderecoProvider.getPaises().subscribe((data) => {
      this.paises = data;
      this.paisList = data;
      this.isLoggedin();
      this.initAutocomplete();
    });
  }

  ngOnInit() {
    if (this.endereco.idPais) {
      this.dubai = Number(this.endereco.idPais) === idDubai ? true : false;

      this.enderecoProvider
        .getEstados(this.endereco.idPais)
        .subscribe((data) => {
          if (data.showEstados) {
            this.estados = data.estadoList;

            if (this.endereco.idEstado) {
              this.enderecoProvider
                .getCidades(this.endereco.idEstado)
                .subscribe((data) => {
                  this.cidades = data;
                });
            }
          }
        });
    }
  }

  isInitForms() {
    this.validations_form_internacional = this.formBuilder.group({
      idPais: new FormControl(
        String(this.endereco.idPais),
        Validators.compose([Validators.required])
      ),
      enderecoGoogle: new FormControl(
        this.endereco.formatado,
        Validators.compose([Validators.required])
      ),
      numero: new FormControl(this.endereco.numero),
      complemento: new FormControl(this.endereco.complemento),
      estadoNome: new FormControl(this.endereco.estadoNome),
      cep: new FormControl(this.endereco.cep),
      logradouro: new FormControl(this.endereco.logradouro),
      bairro: new FormControl(this.endereco.bairro),
      cidadeNome: new FormControl(this.endereco.cidadeNome),
      paisNome: new FormControl(this.endereco.paisNome),
    });

    this.validations_form = this.formBuilder.group({
      idPais: new FormControl(
        this.endereco.idPais ? String(this.endereco.idPais) : '27'
      ),
      cep: new FormControl(this.createCEP(this.endereco.cep)),
      logradouro: new FormControl(this.endereco.logradouro),
      numero: new FormControl(this.endereco.numero),
      complemento: new FormControl(this.endereco.complemento),
      bairro: new FormControl(this.endereco.bairro),
      idEstado: new FormControl(
        this.endereco.idEstado ? String(this.endereco.idEstado) : null
      ),
      idCidade: new FormControl(
        this.endereco.idCidade ? String(this.endereco.idCidade) : null
      ),
      cidadeNome: new FormControl(this.endereco.cidade ? this.endereco.cidade.nome : this.endereco.cidadeNome),
      estadoSigla: new FormControl(this.endereco.estadoSigla),
      caixaPostal: new FormControl(this.endereco.cep),
      latitude: new FormControl(this.endereco.latitude),
      longitude: new FormControl(this.endereco.longitude),
      idRegiao: new FormControl(
        this.endereco.idRegiao ? String(this.endereco.idRegiao) : null
      ),
      paisNome: new FormControl(this.endereco.paisNome),
    });
    this.pais = this.endereco.idPais;
    this.semEstado = Number(this.endereco.idPais) === idBrasil ? false : true;
  }

  isLoggedin() {
    this.userProvider.isLoggedin().then((login) => {
      if (!login || instituicaoConstants.BUSCAR_INTITUICOES == 2) {
        setTimeout(() => {
          this.idInstituicao = this.userProvider.idInstituicao;
          this.enderecoProvider
            .getAreaRegiao(this.idInstituicao)
            .subscribe((data) => {
              this.regiao = data;
            });
        }, 1000);
      } else {
        setTimeout(() => {
          this.userProvider.getDadosInstituicao().then((data) => {
            this.idInstituicao = data.id;
            this.enderecoProvider
              .getAreaRegiao(this.idInstituicao)
              .subscribe((data) => {
                this.regiao = data;
              });
          });
        }, 1000);
      }
    });
  }

  initAutocomplete(): void {
    this.addressElement = this.searchbar?.nativeElement?.querySelector("input");
    this.createAutocomplete(this.addressElement).subscribe();
  }

  createAutocomplete(addressEl: HTMLInputElement): Observable<any> {
    const sigla = this.paisList.find(
      (pais: any) => pais.id == this.pais
    ).codigo;

    if (sigla === "br") {
      return EMPTY;
    }

    const autocomplete = new google.maps.places.Autocomplete(addressEl, {
      componentRestrictions: { country: sigla },
    });

    this.selecionado = true;

    return new Observable((sub: any) => {
      google.maps.event.addListener(autocomplete, "place_changed", () => {
        const place = autocomplete.getPlace();
        this.resetEnderecoFields();

        place.address_components.forEach((address: any) => {
          switch (address.types[0]) {
            case "route":
              this.endereco.logradouro = address.long_name;
              break;
            case "street_number":
              this.endereco.numero = address.long_name;
              break;
            case "sublocality_level_1":
              this.endereco.bairro = address.long_name;
              break;
            case "locality":
              this.endereco.bairro = address.long_name;
              break;
            case "administrative_area_level_2":
              this.endereco.cidadeNome = address.long_name;
              break;
            case "administrative_area_level_1":
              this.endereco.estadoNome = address.long_name;
              this.endereco.estadoSigla = address.short_name;
              if (this.endereco.estadoSigla.length > 2) {
                this.endereco.estadoSigla = this.endereco.estadoSigla.substr(
                  0,
                  2
                );
              }
              break;
            case "country":
              this.endereco.paisNome = address.long_name;
              break;
            case "postal_code":
              this.endereco.cep = address.long_name;
              break;

            default:
              this.endereco;
              break;
          }
        });

        this.processLocationInfo(place);
      });
    });
  }

  private processLocationInfo(place: any) {
    this.endereco.latitude = place.geometry.location.lat();
    this.endereco.longitude = place.geometry.location.lng();
    this.endereco.idPais =
      this.pais !== this.endereco.idPais ? this.pais : this.endereco.idPais;
    this.endereco.formatado =
      this.endereco.idPais == 2 ? place.name : place.formatted_address;
  }

  private resetEnderecoFields() {
    this.endereco.logradouro = null;
    this.endereco.numero = null;
    this.endereco.complemento = null;
    this.endereco.bairro = null;
    this.endereco.cep = null;
    this.endereco.idCidade = null;
    this.endereco.idEstado = null;
    this.endereco.latitude = null;
    this.endereco.longitude = null;
    this.endereco.idRegiao = null;
    this.endereco.cidadeNome = null;
    this.endereco.estadoNome = null;
    this.endereco.estadoSigla = null;
    this.endereco.paisNome = null;
    this.endereco.latlong = false;
    this.endereco.formatado = null;
  }

  getAddress(latLngObj: { lat: any; long: any }) {
    this.mapaService.getStreetAddress(latLngObj).subscribe(
      (s_address) => {
        if (s_address.status == "ZERO_RESULTS") {
          this.mapaService.getAddress(latLngObj).subscribe(
            (address) => {
              this.address = address.results[0].formatted_address;
              this.getAddressComponentByPlace(address.results[0], latLngObj);
            },
            (error) => {
              this.alertError("Error in getting the street address ", error);
            }
          );
        } else {
          this.address = s_address.results[0].formatted_address;
          this.getAddressComponentByPlace(s_address.results[0], latLngObj);
        }
      },
      (error) => {
        this.alertError("No Address found ", error);
      }
    );
  }

  getAddressComponentByPlace(
    place: { address_components: string | any[] },
    latLngObj: { long: any; lat: any }
  ) {
    this.components = {};

    for (var i = 0; i < place.address_components.length; i++) {
      let ac = place.address_components[i];
      this.components[ac.types[0]] = ac.long_name;
    }

    this.selecionado = true;
    this.componentEndereco = this.components;
    this.componentEndereco.longitude = latLngObj.long;
    this.componentEndereco.latitude = latLngObj.lat;

    return this.components;
  }

  buscar() {
    this.enderecoProvider
      .getAreaRegiao(this.idInstituicao.id)
      .subscribe((data) => {
        this.regiao = data;
      });
  }

  private createCEP(cep: string): string {
    const cleaned = cep?.replace(/\D/g, "");
    const hasEightDigits = /^[0-9]{8}$/.test(cleaned);
    return hasEightDigits ? cleaned.replace(/^(\d{5})(\d{3})$/, "$1-$2") : cep;
  }

  mudarPais(event: CustomEvent) {
    this.dubai = Number(event.detail.value) === idDubai ? true : false;
    this.semEstado = Number(event.detail.value) === idBrasil ? false : true;

    if (this.semEstado) {
      const control = this.validations_form_internacional.get("idPais");
      control?.reset();
      control?.setValue(event.detail.value);
      this.pais = event.detail.value;
      this.initAutocomplete();
    } else {
      const opa = this.validations_form.get("idPais");
      opa?.reset();
      opa?.setValue(event.detail.value);
    }

    this.enderecoProvider.getEstados(event.detail.value).subscribe((data) => {
      if (data.showEstados) {
        this.estados = data.estadoList;
        if (this.endereco.idEstado) {
          this.enderecoProvider
            .getCidades(this.endereco.idEstado)
            .subscribe((data) => {
              this.cidades = data;
            });
        }
      }
    });
  }

  mudarEstado(idEstado: any) {
    this.enderecoProvider
      .getCidades(idEstado.detail.value)
      .subscribe((data) => {
        this.cidades = data;
      });
    this.validations_form
      .get("estadoSigla")
      ?.setValue(
        this.estados.find((e: { id: any }) => e.id == idEstado.detail.value)
          ? this.estados.find((e: { id: any }) => e.id == idEstado.detail.value)
              .uf
          : ""
      );
  }

  mudarCidade(idCidade: any) {
    const id = Number(idCidade.detail.value);
    const cidade = this.cidades.find((e: any) => Number(e.id) === id);
    this.validations_form.get('cidadeNome')?.setValue(cidade?.nome || '');
  }

  buscarCep() {
    let cep = this.validations_form.get("cep")?.value.replace(/\D+/g, "");
    if (cep.length == 8) {
      this.enderecoProvider.getCEP(cep).subscribe((data) => {
        setTimeout(() => {}, 1000);

        if (data) {
          this.validations_form.patchValue({
            logradouro: data.logradouro
              ? `${data.tp_logradouro ?? ""} ${data.logradouro}`.trim()
              : null,
            bairro: data.bairro ?? null,
            idEstado: data.estado_id ?? null,
            idCidade: data.cidade_id ?? null,
            cidadeNome: data.cidade ?? null,
            estadoSigla: data.uf ?? null,
            numero: "",
          });

          this.enderecoProvider.getEstados(data.idPais).subscribe((estado) => {
            this.estados = estado.estadoList;
          });

          if (data?.estado_id) {
            this.enderecoProvider
              .getCidades(data.estado_id)
              .subscribe((cidades) => {
                this.cidades = cidades;
              });
          }
        }
      });
    }
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  onSubmitInternacional(validation: any) {
    if (this.dubai) {
      this.onSubmitDubai(validation);
    } else {
      !this.semSalvar
        ? this.salvarEnderecoGoogle()
        : this.updateValidation(validation);
    }
  }

  salvarEnderecoGoogle() {
    const { id, formatado, idPais } = this.endereco;
    this.pessoaProvider
      .salvarEnderecoGoogle(id, formatado, idPais, this.endereco)
      .subscribe((data) => {
        this.modalCtrl.dismiss(data);
      });
  }

  updateValidation(validation: { idPais: any; formatado: any; paisNome: any }) {
    const selectedPais = this.paises.find(
      (pais: { id: any }) => pais.id == validation.idPais
    );
    validation.formatado = this.endereco.formatado;
    validation.paisNome = selectedPais ? selectedPais.nome : "";
    this.modalCtrl.dismiss(validation);
  }

  onSubmit(endereco: {
    idPais: any;
    caixaPostal: any;
    paisNome: any;
    logradouro: any;
    complemento: any;
    cidadeNome: any;
    formatado: null;
    estadoNome: null;
    cep: string;
    numero: any;
    bairro: any;
    idEstado: any;
    idCidade: any;
    idEndereco: any;
  }) {
    const paisNome = this.paises.find(
      (pais: { id: any }) => pais.id == endereco.idPais
    ).nome;

    if (this.semEstado) {
      this.endereco.idPais = endereco.idPais;
      this.endereco.cep = endereco.caixaPostal;
      endereco.paisNome = paisNome;
      this.endereco.logradouro = endereco.logradouro;
      this.endereco.complemento = endereco.complemento;
      this.endereco.cidadeNome = endereco.cidadeNome;
      endereco.formatado = null;
      endereco.estadoNome = null;
    } else {
      this.endereco.idPais = endereco.idPais;
      if (endereco.cep) {
        this.endereco.cep = endereco.cep.replace(/\D+/g, "");
      }
      endereco.paisNome = paisNome;
      this.endereco.logradouro = endereco.logradouro;
      this.endereco.numero = endereco.numero;
      this.endereco.complemento = endereco.complemento;
      this.endereco.bairro = endereco.bairro;
      this.endereco.idEstado = endereco.idEstado;
      this.endereco.idCidade = endereco.idCidade;
      this.endereco.cidadeNome = endereco.cidadeNome;
      endereco.formatado = null;
      endereco.estadoNome = null;
    }

    endereco.idEndereco = this.endereco.id;

    if (this.fromForm) {
      this.modalCtrl.dismiss(endereco);
    } else {
      this.pessoaProvider.salvarEndereco(endereco).subscribe((data) => {
        this.modalCtrl.dismiss(data);
      });
    }
  }

  onSubmitDubai(endereco: {
    idPais: any;
    complemento: any;
    logradouro: any;
    cidadeNome: any;
    estadoNome: any;
    bairro: any;
    numero: any;
    cep: any;
  }) {
    const paisNome = this.paises.find(
      (pais: { id: any }) => pais.id == endereco.idPais
    ).nome;

    this.endereco = {
      complemento: endereco.complemento,
      logradouro: endereco.logradouro,
      cidadeNome: endereco.cidadeNome,
      estadoNome: endereco.estadoNome,
      idEndereco: this.endereco.id,
      idPais: endereco.idPais,
      bairro: endereco.bairro,
      numero: endereco.numero,
      cep: endereco.cep,
      paisNome: paisNome,
      estadoSigla: null,
      formatado: null,
      idEstado: null,
      idCidade: null,
    };

    this.endereco = this.formatarEnderecoDubai(this.endereco);
    this.fromForm
      ? this.modalCtrl.dismiss(this.endereco)
      : this.salvarEndereco(this.endereco);
  }

  private salvarEndereco(endereco: any) {
    this.pessoaProvider.salvarEndereco(endereco).subscribe(
      (data) => this.modalCtrl.dismiss(data),
      (error) => {
        this.alertError("Erro ao salvar o endereço:", error);
      }
    );
  }

  async meuEndereco() {
    let alert = await this.alertCtrl.create({
      header: this.translate.instant("Atenção!"),
      message: this.translate.instant(
        "Deseja atualizar sua localização com base em seu local atual?"
      ),
      buttons: [
        {
          text: this.translate.instant("Cancelar"),
          role: "cancel",
        },
        {
          text: this.translate.instant("Sim"),
          handler: async () => {
            await Geolocation.getCurrentPosition()
              .then((data) => {
                this.validations_form.patchValue({
                  latitude: data.coords.latitude.toString(),
                  longitude: data.coords.longitude.toString(),
                });
              })
              .catch((error) => {
                this.alertError("Erro ao mudar o endereço:", error);
              });

            await Geolocation.getCurrentPosition()
              .then((data) => {
                this.validations_form.patchValue({
                  latitude: data.coords.latitude.toString(),
                  longitude: data.coords.longitude.toString(),
                });
              })
              .catch((error) => {
                this.alertError("Erro ao encontrar a geolocalização:", error);
              });
          },
        },
      ],
    });
    alert.present();
  }

  private async alertError(subHeader: string, message: string) {
    const alert = await this.alertCtrl.create({
      subHeader,
      message,
      buttons: ["OK"],
    });
    await alert.present();
  }

  formatarEnderecoDubai(endereco: {
    formatado?: any;
    complemento?: any;
    logradouro?: any;
    numero?: any;
    bairro?: any;
    cidadeNome?: any;
    cep?: any;
    estadoNome?: any;
    paisNome?: any;
  }) {
    const {
      complemento,
      logradouro,
      numero,
      bairro,
      cidadeNome,
      cep,
      estadoNome,
      paisNome,
    } = endereco;
    const camposEndereco = [
      complemento,
      logradouro,
      numero,
      bairro,
      cidadeNome,
    ];

    let enderecoFormatado = camposEndereco.filter(Boolean).join(", ");

    if (cep) {
      enderecoFormatado += `, ${cep}`;
    }

    if (estadoNome) {
      enderecoFormatado += ` - ${estadoNome}`;
    }

    enderecoFormatado += ` - ${paisNome}`;

    endereco.formatado = enderecoFormatado;

    return endereco;
  }
}
